<template>
    <coach-required v-if="!libraryCoach" />
    <evaluations-view v-else :key="libraryCoach.id" />
</template>

<script>

import { mapState } from "vuex";
import EvaluationsView from "@/views/coach/Evaluations";
import CoachRequired from "@/components/company/CoachRequired";

export default {
    name: "CompanyEvaluations",
    components: { EvaluationsView, CoachRequired },
    computed: {
        ...mapState(['libraryCoach']),
    },
}
</script>
